module.exports = __webpack_public_path__ + "img/mb-main-bg.4991e93.webp";